import { Dialog, DialogTitle, DialogContent, Grid, Box, Button } from "@mui/material";
import { useSelector } from "react-redux";
import { selectCurrentUser } from "../../../../redux/reducers/authSlice"
import { DataGrid, GridToolbar, GridToolbarContainer, GridToolbarDensitySelector, GridToolbarFilterButton, GridToolbarExport, GridToolbarQuickFilterProps, GridToolbarColumnsButton } from "@mui/x-data-grid";
import { random } from "lodash";


const ComisionesDetailModal = (props) => {
  const currentUser = useSelector(selectCurrentUser);
  let componentState = props.compState;

  return (<>
    <Dialog
      onClose={() => {
        props.setShowComisionesDetails(false);
      }}
      open={props.showComisionesDetails}
      minWidth="xl"
      maxWidth="xl"
      fullWidth={true}
    >
      <DialogTitle>Detalles de Comision</DialogTitle>
      <DialogContent dividers={true}>
        <Grid
          container
          spacing={3}
          sx={{ textAlign: "left", justifyContent: "space-evenly" }}
        >
          <Grid item xs={12}>
            <Box sx={{ height: 600 }}>
              {componentState.isLoading && <DataGrid loading={true} />}
              {!componentState.isError && <DataGrid
                getRowId={(r) => r.contratoId}
                rows={Object.values(componentState.contratos?.entities || []).map(r => ({ ...r, titulares: random(0, 5), documento: 'https://www.orimi.com/pdf-test.pdf' }))}
                columns={[]}
                rowsPerPageOptions={[5]}
                components={{
                  Toolbar: () => {
                    return <GridToolbarContainer><GridToolbarColumnsButton></GridToolbarColumnsButton> <GridToolbarFilterButton></GridToolbarFilterButton> <GridToolbarDensitySelector></GridToolbarDensitySelector>
                      {currentUser?.permisos?.includes('export-data') ? <GridToolbarExport></GridToolbarExport>
                        : ''}</GridToolbarContainer>
                  }
                }}
                componentsProps={{
                  toolbar: {
                    showQuickFilter: true,
                    quickFilterProps: { debounceMs: 500 },
                  },
                }}
              />}
            </Box>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogContent dividers={true} sx={{ overflowY: "clip" }}>
        <Grid item style={{ float: "right", paddingBottom: "10px" }}>
          <Button
            variant="contained"
            onClick={() => props.setShowComisionesDetails(false)}
            sx={{ marginRight: "5px" }}
          >
            {"Aceptar"}
          </Button>
          <Button
            variant="outlined"
            onClick={() => {
              props.setShowComisionesDetails(false);
            }}
          >
            {"Cancelar"}
          </Button>
        </Grid>
      </DialogContent>
    </Dialog>
  </>)
}
export default ComisionesDetailModal;